import styled from '@emotion/styled';
import { StepContainer } from 'UI';

export const AddonStepContainer = styled(StepContainer)`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;
